// Constants used only by the Assistant feature.

// Inline-alert fallback when a pre-stream error has no parseable backend `message`
// (e.g. an edge-generated 401/502 with a non-JSON body).
export const PRE_STREAM_FALLBACK_MESSAGE =
  "Couldn't verify the agent right now. Give it a moment and try again.";

export const PROMPT_TYPE = {
  CATCH_ME_UP: "catchMeUp",
  WAS_MY_NAME_MENTIONED: "wasMyNameMentioned",
  WHOS_WHO: "whosWho",
  FREEFORM: "freeform",
};
